import {
    CacheType,
    createObservableDataAction,
    IAction,
    IActionContext,
    IActionInput,
    ICreateActionContext,
    IRequestContext
} from '@msdyn365-commerce/core';

import { BaseCollectionInput, createBaseCollectionInput } from "./base-collection-action";
import { IGCProductTradeAgreementsEntity } from '../../../actions/AlternateItemsEntity.g';
import { AsyncResult, DataServiceQuery, executeAction, IContext, IDataServiceRequest, IQueryResultSettings, ProductRefinerValue, ProductSearchCriteria, ProductSearchResult } from '@msdyn365-commerce/retail-proxy';
// import { searchByCriteriaAsync } from '@msdyn365-commerce/retail-proxy/dist/DataActions/ProductsDataActions.g';
import { getProductsSalesAgreementAsync } from '../../../actions/getProductsSalesAgreement';
import { getAttributeInfoAsync } from '../../../actions/gc-get-attributeInfo';
import { IAttributeInfo } from '../search-result-container';


export class GetCustomProductsTradeAgreementsCollectionInput extends BaseCollectionInput implements IActionInput {
    /**
     * The cache object type.
     * @returns The cache object type.
     */
    public getCacheObjectType = (): string => 'GetCustomProductsTradeAgreements';

    /**
     * The data cache type.
     * @returns The data cache type.
     */
    public dataCacheType = (): CacheType => {
        // if (
        //     this.pageType !== 'Category' ||
        //     (this.refiners && this.refiners.length > 0) ||
        //     (this.queryResultSettings && this.queryResultSettings.Sorting && this.queryResultSettings.Sorting.Columns && this.queryResultSettings.Sorting.Columns.length > 0)
        // ) {
        //     return 'request';
        // }
        return 'none';

    };
}

const createInput = (args: ICreateActionContext<{ itemsPerPage: number ;includedAttributes: boolean | undefined }>): IActionInput => {
    const input = createBaseCollectionInput(args, GetCustomProductsTradeAgreementsCollectionInput);

    // Set Top
    if (input.queryResultSettings.Paging && args.config) {
        input.queryResultSettings.Paging.Top = args.config.itemsPerPage || 1;
    }

    // Set Skip
    if (input.queryResultSettings.Paging && args.requestContext.query && args.requestContext.query.skip) {
        input.queryResultSettings.Paging.Skip = +args.requestContext.query.skip;
    }

    input.queryResultSettings.count = true;

    return input;
};

function productsQuery(recordId?: number): DataServiceQuery {
    var key = (recordId) ? { RecordId: recordId } : null;
    return new DataServiceQuery("Products", "Product", "ProductClass", key);
}

export function gcCreateSearchByCriteriaInput(queryResultSettings: IQueryResultSettings, searchCriteria?: ProductSearchCriteria | null): IDataServiceRequest {
    const query = productsQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation('SearchByCriteria', true,         'ProductSearchResultClass'
      , 'true', {bypassCache: 'get', returnEntity: 'ProductSearchResult'}, {searchCriteria: searchCriteria });
}

export function gcSearchByCriteriaAsync(context: IContext, searchCriteria?: ProductSearchCriteria | null):AsyncResult<ProductSearchResult[]> {
    const request = gcCreateSearchByCriteriaInput(context.queryResultSettings!, searchCriteria);
    return executeAction<ProductSearchResult[]>(request, context);
}

function hydrateActiveFilterRefinersFromUrl (requestContext: IRequestContext): string {
    if(window)
    {
        const urlSearchString = window && window.location && window.location.search;
        const params = new URLSearchParams(urlSearchString);
        const compressedRefinerArray = params.get('activeFilter') && params.get('activeFilter')!.length > 0 ? JSON.parse(decodeURIComponent(params.get('activeFilter')??'')) : '';
        if (!compressedRefinerArray || compressedRefinerArray.length === 0) {
            return '';
        }
        return compressedRefinerArray??'';
    }
    return '';
}


async function action(
    input: GetCustomProductsTradeAgreementsCollectionInput,
    context: IActionContext
): Promise<IGCProductTradeAgreementsEntity[]> {
    let prod : IGCProductTradeAgreementsEntity[]=[];
    let promise: AsyncResult<ProductSearchResult[]>;
    let searchProductId;
    const searchCriteriaInput: ProductSearchCriteria = {};
    try{
    searchCriteriaInput.Context = { ChannelId: context.requestContext.apiSettings.channelId, CatalogId: context.requestContext.apiSettings.catalogId };
    searchCriteriaInput.Refinement = input.refiners;
    searchCriteriaInput.IncludeAttributes = input.includeAttributes;
    searchCriteriaInput.SkipVariantExpansion = true;
    const defaultNumber: number = 0;
     const customRefiner = hydrateActiveFilterRefinersFromUrl(context.requestContext) !== ''? hydrateActiveFilterRefinersFromUrl(context.requestContext) : 'Active';
    if(customRefiner && customRefiner.length > 0 && customRefiner !== 'All')
    {
     const result = await getAttributeInfoAsync({ callerContext: context }, 'active');
     const attributeInfo: IAttributeInfo = {};
     attributeInfo.Name = result.gcAttributeInfo?.Name;
        attributeInfo.AttributeGroupId = result.gcAttributeInfo?.AttributeGroupId;
        attributeInfo.DataType = result.gcAttributeInfo?.DataType;
        attributeInfo.LowerBound = result.gcAttributeInfo?.LowerBound;
        attributeInfo.UpperBound = result.gcAttributeInfo?.UpperBound;
        attributeInfo.RecId = result.gcAttributeInfo?.RecId;
        if(!searchCriteriaInput.Refinement || (searchCriteriaInput.Refinement.length === 0) ||  searchCriteriaInput.Refinement.find(x => x.RefinerRecordId === attributeInfo.RecId) === undefined)
        {
            if(searchCriteriaInput.Refinement === undefined)
            {
                searchCriteriaInput.Refinement = [];
            }
            const activeFilter: ProductRefinerValue = {
                DataTypeValue: attributeInfo.DataType,
                LeftValueBoundString: customRefiner === 'Active' ? attributeInfo.UpperBound!.toString() : attributeInfo.LowerBound!.toString(),
                RefinerRecordId: attributeInfo.RecId,
                RightValueBoundString: customRefiner === 'Active' ? attributeInfo.UpperBound!.toString() : attributeInfo.LowerBound!.toString(),
                ExtensionProperties: [],
                RefinerSourceValue: 1,
                RowNumber: 0,
                SwatchColorHexCode: '',
                SwatchImageUrl: '',
                UnitText: ''
            };
            searchCriteriaInput.Refinement.push(activeFilter);
        }
    }
    if (input.pageType === 'Category' || (context.requestContext.query && context.requestContext.query.categoryId)) {
        if (input.category) {
            searchCriteriaInput.CategoryIds = [input.category || defaultNumber];
            promise = gcSearchByCriteriaAsync(
                {
                    callerContext: context,
                    queryResultSettings: input.queryResultSettings
                },
                searchCriteriaInput
            );
        } else {
            throw new Error(
                '[GetFullProductsForCollection]Category Page Detected, but no global categoryId found'
            );
        }
    } else if (input.searchText && (context.requestContext.query && context.requestContext.query.q)) {
        searchCriteriaInput.SearchCondition = input.searchText;
        promise = gcSearchByCriteriaAsync(
            {
                callerContext: context,
                queryResultSettings: input.queryResultSettings
            },
            searchCriteriaInput
        );
    } else if (input.searchText && (context.requestContext.query && context.requestContext.query.productId && context.requestContext.query.recommendation)) {
        const searchObject = JSON.parse(input.searchText);
        searchProductId = Number(searchObject.ProductId);
        if (Number.isNaN(searchProductId)) {
            throw new Error('Failed to cast search product id into a number.');
        } else if (!searchObject.Recommendation) {
            throw new Error('Failed to retrieve the Recommendation.');
        } else {
            searchCriteriaInput.RecommendationListId = searchObject.Recommendation;
            searchCriteriaInput.Ids = [searchProductId || defaultNumber];
            promise = gcSearchByCriteriaAsync(
                {
                    callerContext: context,
                    queryResultSettings: input.queryResultSettings
                },
                searchCriteriaInput
            );
        }
    } else {
        throw new Error(
            '[GetFullProductsForCollection]Search Page Detected, but no q= or productId= query parameter found'
        );
    }

    const productSearchResults = await promise;
    if(productSearchResults)
    {
        const prodRecId:number[] =[];
        productSearchResults.forEach((product,idx)=>{
            prodRecId.push(product.RecordId);
        });
        var productTradeAgreement = await getProductsSalesAgreementAsync({callerContext: context},prodRecId);
        if(productTradeAgreement && productTradeAgreement.gcProductTradeAgreementsEntity)
        {
            prod = productTradeAgreement.gcProductTradeAgreementsEntity;
        }
    }
    return prod;
    }
    catch(error){
        console.log(error);
    }
    return [];
}

export const actionDataAction = createObservableDataAction({
    id: 'GetCustomProductsTradeAgreements',
    action: <IAction<IGCProductTradeAgreementsEntity[]>>action,
    input: createInput
});

export default actionDataAction;